<template>
  <div class="ima-modals">

    <b-modal :active="modals.isOpen">
      <div class="box">
        <div class="ima-modals__header">
          <button class="button ima-modals__close-button" type="button" @click="closeModals">
            <b-icon icon="close"></b-icon>
          </button>
        </div>
        <ima-add-sign-to-shopping-cart-modal v-if="modals.isAddSignToShoppingCartModalOpen" />
        <ima-copy-sign-modal v-if="modals.isCopySignModalOpen" />
        <ima-exhibition-modal v-if="modals.isExhibitionModalOpen" />
        <ima-shopping-cart-overview-modal v-if="modals.isShoppingCartOverviewModalOpen" />
        <ima-sign-modal v-if="modals.isSignModalOpen" />
        <ima-slogan-modal v-if="modals.isSloganModalOpen" />
        <ima-transfer-modal v-if="modals.isTransferModalOpen" />
        <ima-user-modal v-if="modals.isUserModalOpen" />
        <ima-variant-modal v-if="modals.isVariantModalOpen" />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { closeModals } from '@/store/modules/modals'
import AddSignToShoppingCartModal from '@/components/modals/AddSignToShoppingCartModal'
import CopySignModal from '@/components/modals/CopySignModal'
import ExhibitionModal from '@/components/modals/ExhibitionModal'
import ShoppingCartOverviewModal from '@/components/modals/ShoppingCartOverviewModal'
import SignModal from '@/components/modals/SignModal'
import SloganModal from '@/components/modals/SloganModal'
import TransferModal from '@/components/modals/TransferModal'
import UserModal from '@/components/modals/UserModal'
import VariantModal from '@/components/modals/VariantModal'

export default {
  name: 'ima-modals',
  components: {
    'ima-add-sign-to-shopping-cart-modal': AddSignToShoppingCartModal,
    'ima-copy-sign-modal': CopySignModal,
    'ima-exhibition-modal': ExhibitionModal,
    'ima-shopping-cart-overview-modal': ShoppingCartOverviewModal,
    'ima-sign-modal': SignModal,
    'ima-slogan-modal': SloganModal,
    'ima-transfer-modal': TransferModal,
    'ima-user-modal': UserModal,
    'ima-variant-modal': VariantModal
  },
  methods: {
    ...mapMutations([closeModals])
  },
  computed: {
    ...mapState(['modals'])
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.ima-modals {
  // .modal-background {
  //   background-color: rgba(10, 10, 10, 0.5);
  // }
  .modal-close {
    display: none;
  }

  &__header {
    text-align: right;
  }

  &__close-button {
    border: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Modals.vue